import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface CancelContractModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (contratos: { numero_documento: string; razao_cancelamento: string }[]) => void;
  idDocumento: string;
}

const CancelContractModal: React.FC<CancelContractModalProps> = ({ show, onHide, onSubmit, idDocumento }) => {
  const [numeroDocumento, setNumeroDocumento] = useState(idDocumento);
  const [razaoCancelamento, setRazaoCancelamento] = useState('');
  const [contratos, setContratos] = useState<{ numero_documento: string; razao_cancelamento: string }[]>([]);

  const handleAddContrato = () => {
    if (numeroDocumento && razaoCancelamento) {
      setContratos([...contratos, { numero_documento: numeroDocumento, razao_cancelamento: razaoCancelamento }]);
      setNumeroDocumento('');
      setRazaoCancelamento('');
    }
  };

  const handleRemoveContrato = (index: number) => {
    setContratos(contratos.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    onSubmit(contratos);
    setContratos([]);
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      className="hana-modal"
      centered
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="hana-modal-title">
          Cancelar Contrato
          {contratos.length > 0 && (
            <span className="hana-badge ms-2">
              {contratos.length} {contratos.length === 1 ? 'contrato' : 'contratos'} selecionado{contratos.length === 1 ? '' : 's'}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4">
        <div className="hana-form-group mb-4">
          <label className="hana-label mb-2">Número do Documento</label>
          <input
            type="text"
            className="form-control hana-input"
            placeholder="Digite o número do documento"
            value={numeroDocumento}
            onChange={e => setNumeroDocumento(e.target.value)}
          />
        </div>
        <div className="hana-form-group mb-4">
          <label className="hana-label mb-2">Razão do Cancelamento</label>
          <input
            type="text"
            className="form-control hana-input"
            placeholder="Digite a razão do cancelamento"
            maxLength={30}
            value={razaoCancelamento}
            onChange={e => setRazaoCancelamento(e.target.value)}
          />
        </div>
        <Button 
          variant="outline-primary" 
          className="hana-button mb-4" 
          onClick={handleAddContrato} 
          disabled={!numeroDocumento || !razaoCancelamento}
        >
          Adicionar contrato
        </Button>
        
        {contratos.length > 0 && (
          <div className="hana-list-container">
            <h6 className="hana-subtitle mb-3">Contratos Selecionados</h6>
            <ul className="list-group hana-list">
              {contratos.map((contrato, idx) => (
                <li key={idx} className="list-group-item hana-list-item d-flex justify-content-between align-items-center">
                  <div>
                    <strong className="d-block">{contrato.numero_documento}</strong>
                    <small className="text-muted">{contrato.razao_cancelamento}</small>
                  </div>
                  <Button 
                    variant="outline-danger" 
                    size="sm" 
                    className="hana-button-danger"
                    onClick={() => handleRemoveContrato(idx)}
                  >
                    Remover
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button 
          variant="outline-secondary" 
          className="hana-button me-2"
          onClick={onHide}
        >
          Fechar
        </Button>
        <Button 
          variant="primary" 
          className="hana-button-primary"
          onClick={handleSubmit}
          disabled={contratos.length === 0}
        >
          Confirmar Cancelamento
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelContractModal; 